<template>
  <v-card :class="[orientation, type]" class="post-card mx-auto">
    <div class="figure">
      <v-img :src="img" class="white--text" height="200px" />
    </div>
    <div class="properties">
      <strong class="use-text-tile2">
        <span>{{ title }}</span>
      </strong>
      <v-card-subtitle>{{ formattedDate }}</v-card-subtitle>
      <v-card-text class="desc">
        <span class="text--primary">
          <span>{{ desc }}</span>
        </span>
      </v-card-text>
      <v-card-actions>
        <v-btn
          :small="orientation === 'landscape'"
          :to="localePath(href)"
          outlined
          class="action-btn"
          color="primary"
        >{{$t("landing.btn_detail")}}</v-btn>
      </v-card-actions>
    </div>
  </v-card>
</template>

<style scoped lang="scss">
@import "./post-news-card";
</style>

<script>
export default {
  computed: {
    formattedDate() {
      if (!this.date) return "";

      const parsedDate = new Date(this.date);
      if (Number.isNaN(parsedDate.getTime())) {
        return this.date;
      }

      const locale = this.$i18n?.locale === "ar" ? "ar-EG" : "en-US";
      return new Intl.DateTimeFormat(locale, {
        year: "numeric",
        month: "long",
        day: "2-digit"
      }).format(parsedDate);
    }
  },
  props: {
    img: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    date: {
      type: String,
      required: true
    },
    desc: {
      type: String,
      required: true
    },
    orientation: {
      type: String,
      default: "portrait"
    },
    type: {
      type: String,
      default: "full" // available props: full, rounded, over, oval
    },
    href: {
      type: String,
      default: "#"
    }
  }
};
</script>
